import app from "flarum/app";
import TotalRankingsPage from '../components/TotalRankingsPage';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

export default function () {
  app.routes['total_rankings.index'] = { path: '/total_rankings', component: TotalRankingsPage };
  app.routes['monthly_rankings.index'] = { path: '/monthly_rankings', component: TotalRankingsPage };
  User.prototype.AdvPoints = Model.attribute('AdvPoints');
  User.prototype.AdvPointsMonthly = Model.attribute('AdvPointsMonthly');
};
